import { render, staticRenderFns } from "./ForceChangePassword.vue?vue&type=template&id=2028c09e&"
import script from "./ForceChangePassword.vue?vue&type=script&lang=js&"
export * from "./ForceChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ForceChangePassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports